export function getCurrentBrowserPathWithSearch(defaultPath = '/') {
  if (typeof window === 'undefined') {
    return defaultPath;
  }

  const pathname = window.location.pathname || defaultPath;
  const search = window.location.search || '';
  return `${pathname}${search}`;
}

export function getCurrentBrowserSearchParam(name: string) {
  if (typeof window === 'undefined') {
    return null;
  }

  return new URLSearchParams(window.location.search).get(name);
}
